export const contactsEndpoints = {
  createContacts: (clientId: string) => `/client/contacts/${clientId}`,
  getContacts: (clientId: string) => `/client/contacts/${clientId}`,
  getContact: (clientId: string, contactId: string) => `/client/contacts/${clientId}/${contactId}`,
  /** Base path for generic dropdown (query params built in queries layer) */
  dropdown: "/dropdown",
  /** Base path for client contact details dropdown e.g. phone/email (query params in queries layer) */
  clientContactDetailsDropdown: "/dropdown/client-contact-details",
  /** Base path for static lookup dropdowns e.g. sms_status */
  lookups: "/dropdown/lookups",
};
